import React from 'react';
import { RadioGroupContext } from './useRadioGroup';
const RadioGroup = ({ name, onChange, children, selectedValue, }) => {
    const contextValues = React.useMemo(() => {
        return { name, selectedValue, onChange };
    }, [name, selectedValue, onChange]);
    return (React.createElement(RadioGroupContext.Provider, { value: contextValues }, children));
};
export default RadioGroup;
//# sourceMappingURL=RadioGroup.js.map